import { render } from "./WelcomeButton.vue?vue&type=template&id=7f684699"
import script from "./WelcomeButton.vue?vue&type=script&lang=ts"
export * from "./WelcomeButton.vue?vue&type=script&lang=ts"
script.render = render

export default script